import { CheckPluginStatusesEnum } from 'CorePackage/MainModule/enums/CheckPluginStatusesEnum';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { apiGet, apiPost } from '../common/apiTools';

export interface IStatusInfoProps {
  status: CheckPluginStatusesEnum;
}

export async function getStatusInfoRead(): Promise<IStatusInfoProps> {
  return apiGet<IStatusInfoProps>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/signature/user/status-info-read`);
}

export async function setStatusInfoRead(data: IStatusInfoProps) {
  return apiPost({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/signature/user/status-info-read`,
    body: data,
  });
}
